import { storageGet, storageSet } from './libs/localStorage';
import { addHandlerClickOnCompareIcon } from './compare';

let favoritesLs = storageGet('favorites');
let favItems = {};
let favIds = [];
if (favoritesLs) {
  favItems = favoritesLs;
  favIds = Object.keys(favItems);
}
const favoritesSelector = '[data-entity="favorite-checkbox"]';
const favoriteUpdate = new CustomEvent('favoriteUpdate');

const setActiveFavoriteIcons = () => {
  const inputs = document.querySelectorAll(favoritesSelector);
  inputs.forEach((el) => {
    const id = el.dataset.id;
    const isActive = favIds.includes(id);
    if (isActive) {
      el.classList.add('is-active');
    } else {
      el.classList.remove('is-active');
    }
  });
};
const setFavoritesItems = (result) => {
  favItems = result.items;
  storageSet({ key: 'favorites', value: favItems });
  storageSet({ key: 'lastTimeFavoritesUpdate', value: Date.now() });
  window.dispatchEvent(favoriteUpdate);
  favIds = Object.keys(favItems);
  queueMicrotask(() => {
    setActiveFavoriteIcons();
  });
};
window.updateFavoritesItems = setFavoritesItems;

const getFavoriteItems = async () => {
  const response = await fetch('/local/ajax/favorites/getItems.php', {
    method: 'POST',
  });
  if (response.ok) {
    const result = await response.json();
    setFavoritesItems(result);
  }
};

if (favoritesLs === null) {
  getFavoriteItems();
}

const addFavoriteItem = async (id) => {
  const queryString = new URLSearchParams({
    id,
  });
  const response = await fetch(`/local/ajax/favorites/addItem.php?${queryString}`, {
    method: 'PUT',
  });
  if (response.ok) {
    const result = await response.json();
    setFavoritesItems(result);
  }
};
const deleteFavoriteItem = async (id) => {
  const queryString = new URLSearchParams({
    id,
  });
  const response = await fetch(`/local/ajax/favorites/deleteItem.php?${queryString}`, {
    method: 'DELETE',
  });
  if (response.ok) {
    const result = await response.json();
    const { items } = result;
    if (Array.isArray(items) && !items.length) {
      const modalWrapper = document.querySelector('[data-list-type="jsFavoriteList"]');

      if (modalWrapper) {
        modalWrapper.classList.remove('_with-popup--active');

        const modal = modalWrapper.querySelector('.buttons-bottom-header__item-popup');
        modal.style.display = 'none';
        setTimeout(() => {
          modal.style.display = 'block';
        }, 550);
      }
    }
    setFavoritesItems(result);
  }
};
const changeFavoriteItem = (el) => {
  const id = el.dataset.id;
  const inList = favIds.includes(id);
  if (inList) {
    deleteFavoriteItem(id);
  } else {
    addFavoriteItem(id);
  }

  if (window.location.pathname.includes('favorites/catalog')) {
    setTimeout(() => {
      window.location.reload();
    }, 500);
  }
};
const addHandlerClickOnFavoriteIcon = (withUniqueCheck = false) => {
  const inputs = document.querySelectorAll(favoritesSelector);
  inputs.forEach((el) => {
    if (el.classList.contains('init') && !withUniqueCheck) return;

    el.addEventListener('click', () => {
      changeFavoriteItem(el);
    });
    el.classList.add('init');
  });
};
const initScripts = () => {
  queueMicrotask(() => {
    window.initFilter();
    window.initBuyScript();
    addHandlerClickOnCompareIcon();
    window.addHandlerClickOnFavoriteIcon();
    window.lazyUpdate();
    window.initShowMoreScript();
    window.spollerUpd();
    window.initSlimSelect();
    window.initSmartFilterToggler();
    window.moveFilterFunc();
    window.SwitchView.init();
    setActiveFavoriteIcons();
    window.setActiveCompareIcons();
  });
};
const rerenderFavoritesPage = async (url) => {
  window.loaderShow('[data-ajax="catalog"]');

  try {
    const rawResponse = await fetch(url);
    const responseToString = await rawResponse.text();
    const rawHtml = new DOMParser().parseFromString(responseToString, 'text/html');

    const oldPageNode = document.querySelector('[data-ajax="catalog"]');
    const newPageNode = rawHtml.querySelector('[data-ajax="catalog"]');

    if (oldPageNode && newPageNode) {
      oldPageNode.innerHTML = newPageNode.innerHTML;
      initScripts();
    }
  } catch (err) {
    window.loaderHide('[data-ajax="catalog"]');
  }
};

setActiveFavoriteIcons();
addHandlerClickOnFavoriteIcon();

window.updateFavorites = () => {
  favoritesLs = storageGet('favorites');
  favItems = favoritesLs;
  if (favItems) {
    favIds = Object.keys(favItems);
  }
  setActiveFavoriteIcons();
};
window.addEventListener('phpSessIdUpdate', () => {
  window.isTrueUpdate = true;

  getFavoriteItems();

  setTimeout(() => {
    window.isSessionIdUpdate = false;
  }, 1000);
});

let oldFavoritesList = favoritesLs;
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible' && window?.location?.pathname.startsWith('/favorites/catalog/')) {
    const newFavoritesList = storageGet('favorites');

    if (Object.keys(oldFavoritesList).length !== Object.keys(newFavoritesList).length) {
      rerenderFavoritesPage(window.location.pathname);
      oldFavoritesList = favoritesLs;
    }
  }
});

window.addHandlerClickOnFavoriteIcon = addHandlerClickOnFavoriteIcon;
window.setActiveFavoriteIcons = setActiveFavoriteIcons;
